export const AC = { name: 'Active', code: 'AC' };
export const CL = { name: 'Closed', code: 'CL' };
export const RS = { name: 'Restricted', code: 'RS' };
export const TM = { name: 'Terminated', code: 'TM' };
export const FZ = { name: 'Frozen', code: 'FZ' };
export const AB = { name: 'Abandoned', code: 'AB' };
